import styled from 'styled-components';
import { TCalloutTheme } from '../common/Callout/Callout.types';
import { THBCalloutPopoverTheme } from './HBCalloutPopover.types';
import HBLinkButton from '../HBLinkButton/HBLinkButton';
import colors from '../../styles/colors';
import { vars } from '../../theme';
import { ArrowRight16 } from '@honeybook/icons';
import { upToSmall } from '../../styles/breakpoints';
import HBText from '../HBText/HBText';

export const getCalloutPopoverStyles: (
    boolean?
) => Record<TCalloutTheme, THBCalloutPopoverTheme> = (isUpToSmall: boolean) => {
    return {
        neutral: {
            backgroundColor: vars.colors.surface.container,
            textColor: 'text.primary',
            iconColor: vars.colors.text.primary,
            paginationColor: 'text.secondary',
            primaryActionTheme: 'primary',
            secondaryActionTheme: isUpToSmall
                ? 'secondary-solid-secondary'
                : 'secondary-invisible-secondary',
            closeButtonTheme: 'dark',
            theme: 'calloutNeutral',
            LinkButtonTheme: 'neutral'
        },
        accent: {
            // Unsupported: colors.purple800 — no semantic equivalent (see .claude/rules/styling.md)
            backgroundColor: colors.purple800,
            textColor: 'text.invertedPrimary',
            iconColor: vars.colors.text.invertedPrimary,
            paginationColor: 'text.invertedSecondary',
            primaryActionTheme: 'secondary-solid-primary',
            secondaryActionTheme: 'secondary-translucent-secondary',
            closeButtonTheme: 'light',
            theme: 'calloutAccent',
            LinkButtonTheme: 'link-button-accent'
        }
    };
};
export const MediaContainer = styled.div`
    max-width: 380px;
    > * {
        display: flex;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const IconAndTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    min-width: 200px;
    max-width: 380px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    ${upToSmall} {
        gap: 16px;
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: flex-end;
    // negative margin to align between actions top margin and link button footer
    margin-top: -4px;
`;

export const Arrow = styled(ArrowRight16)`
    margin-left: -6px;
    line-height: 0;
    display: block;
`;

export const LinkButton = styled(HBLinkButton)`
    height: 18px;
`;

export const Title = styled(HBText)`
    padding-right: 20px;
`;
